import { Heart } from 'lucide-react'

interface LetterCardProps {
  body: string
  showSeal?: boolean
  showSignature?: boolean
  className?: string
}

export default function LetterCard({ body, showSeal = true, showSignature = true, className = '' }: LetterCardProps) {
  return (
    <div className={`letter-card p-8 max-w-2xl mx-auto ${className}`}>
      {/* Decorative top border */}
      <div className="flex justify-center mb-6">
        <div className="flex items-center gap-2">
          <div className="w-12 h-px bg-rose-200" />
          {showSeal && (
            <Heart className="w-5 h-5 text-rose-400 fill-rose-400" />
          )}
          <div className="w-12 h-px bg-rose-200" />
        </div>
      </div>

      {/* Letter content */}
      <div className="paper-texture rounded-lg p-6 min-h-[200px]">
        <p className="font-handwriting text-2xl text-ink whitespace-pre-wrap letter-body">
          {body}
        </p>
      </div>

      {/* Decorative bottom */}
      {showSignature && (
        <div className="flex justify-end mt-6 pr-4">
          <span className="font-handwriting text-lg text-rose-400 italic">
            ~ Anonim 💌
          </span>
        </div>
      )}
    </div>
  )
}
